<div class="w-full min-h-screen flex flex-col bg-gray-100 aarni-font">
    <div
        class="relative w-full h-[530px] md:h-[720px] bg-cover bg-center text-white
         bg-[url('assets/img/iqac/internal-banner-iqac-mobile.webp')]
         md:bg-[url('assets/img/iqac/internal-banner-iqac-desktop.webp')]"
    >
        <div class="absolute inset-0 bg-black opacity-60 z-0"></div>
        <div class="absolute top-4 left-4 right-4 z-20 flex flex-col md:flex-row md:justify-between items-center gap-3">
            <a href="/"><img src="assets/img/logo/arni-updated-logo.png" alt="Arni University Logo" class="h-16"/></a>

            <div class="flex flex-col md:flex-row gap-3 md:items-center">
                <a href="https://student.arni.in/auth/login" target="_blank"
                   class="bg-cyan-500 text-white px-4 py-2 rounded text-sm hover:bg-cyan-600 text-center">
                    STUDENT LOGIN
                </a>
                <a href="https://admin.arni.in/" target="_blank"
                   class="bg-cyan-500 text-white px-4 py-2 rounded text-sm hover:bg-cyan-600 text-center">
                    ADMIN LOGIN
                </a>
            </div>
        </div>

        <div class="relative z-10 flex flex-col justify-center items-center h-full text-white text-center px-4">
            <h1 class="text-3xl md:text-4xl font-bold mb-4">Grievance Redressal Online Portal</h1>
            <a href="https://arni.in/2024/StuGR.aspx" target="_blank"
               class="bg-cyan-500 hover:bg-cyan-600 text-white font-semibold px-6 py-2 rounded shadow">
                LODGE COMPLAINT
            </a>
        </div>
    </div>
    <main class="relative z-10 px-4 md:px-8 pb-12 bg-blue-50">
        <div class="p-6 mx-auto max-w-7xl">
            <div class="grid md:grid-cols-2 gap-10">
                <div class="space-y-12">
                    <section>
                        <h2 class="text-xl font-semibold mb-4">About Us</h2>
                        <p class="mb-4 text-justify text-gray-800">
                            At ARNI University, we believe that every voice is important and deserves to be heard. Being
                            one of the foremost educational institutions, it is our responsibility to provide a
                            transparent, fair, and inclusive academic environment where every student matters. With
                            highly professional and experienced faculty members, our Grievance Redressal Mechanism is
                            designed to address concerns and complaints promptly, respectfully, and by university
                            policies and regulatory guidelines.
                        </p>
                        <p class="mb-4 text-justify text-gray-800">
                            We are committed to providing a secure and smooth learning experience to our valuable
                            students. Thus, no matter the concern related to academics, administration, examination,
                            faculty behavior, or facilities, students can raise their grievances through a clear and
                            systematic process. We understand that unresolved issues can impact the entire learning
                            journey and be stressful too, which is why our grievance redressal committee is empowered
                            and responsible for ensuring timely resolutions with confidentiality and integrity.
                        </p>
                        <h2 class="my-2 text-xl font-bold">How the process works:</h2>
                        <ul class="list-disc text-justify text-gray-800 ps-5">
                            <li><span class="font-semibold">Submission:</span> Students can submit grievances online
                                through <a class="text-blue-500 underline" href="https://arni.in/2024/StuGR.aspx">student
                                    grievance portal</a> or
                                offline by visiting the grievance cell.
                            </li>
                            <li><span class="font-semibold">Acknowledgement:</span> Every grievance submitted will be
                                acknowledged within 48 hours or
                                before, and transferred to the appropriate person.
                            </li>
                            <li><span class="font-semibold">Review & Action:</span> The grievance redressal committee
                                will review the issue, conduct a
                                necessary investigation, and take appropriate action within 15 working days.
                            </li>
                            <li><span class="font-semibold">Resolution Communication:</span> Students will receive a
                                formal communication about the outcome
                                and solution provided.
                            </li>
                        </ul>
                        <p class="my-2 text-justify text-gray-800 ps-1">We encourage students to first approach the
                            concerned department or
                            authority. If the issue
                            remains unresolved, the grievance may be escalated to the committee.
                        </p>
                        <p class="text-justify text-gray-800 ps-1">Your feedback and concerns are vital to the
                            continuous improvement of
                            our services. We assure
                            you of our full commitment to fairness, non-retaliation, and resolution with empathy.
                        </p>
                    </section>
                </div>

                <div class="space-y-12">
                    <section>
                        <h2 class="text-xl font-semibold mb-4">Grievance Notifications</h2>
                        <div class="space-y-4">
                            <a href="/quick-links/announcements"
                               class="block border border-cyan-700 bg-cyan-50 text-cyan-700 px-4 py-3 rounded shadow hover:bg-cyan-100">
                                🔔 Notification for ARNI University Grievance Redressal Committee
                            </a>
                            <a href="/quick-links/announcements"
                               class="block border border-cyan-700 bg-cyan-50 text-cyan-700 px-4 py-3 rounded shadow hover:bg-cyan-100">
                                🔔 Notification for Student and Staff Grievance Handling Procedure
                            </a>
                        </div>
                    </section>

                    <section>
                        <h2 class="text-xl font-semibold mb-4">Grievance Statistics</h2>
                        <div class="flex flex-col sm:flex-row gap-6">
                            <div class="bg-red-500 text-white text-center px-8 py-6 rounded shadow w-full sm:w-1/2">
                                <p class="text-3xl font-bold">0</p>
                                <p class="uppercase mt-2">New Grievances</p>
                            </div>
                            <div class="bg-emerald-500 text-white text-center px-8 py-6 rounded shadow w-full sm:w-1/2">
                                <p class="text-3xl font-bold">32</p>
                                <p class="uppercase mt-2">Resolved Grievances</p>
                            </div>
                        </div>
                    </section>

                    <section>
                        <h2 class="text-xl font-semibold mb-4">FAQ</h2>
                        <div *ngFor="let faq of faqs; index as i" class="mb-4 border border-gray-200 rounded">
                            <button
                                (click)="toggleFAQ(i)"
                                class="w-full text-left px-4 py-3 bg-blue-200 hover:bg-blue-300 rounded-t focus:outline-none flex justify-between items-center"
                            >
                                <span>{{ faq.question }}</span>
                                <span class="text-xl font-bold">
        {{ faq.isOpen ? '−' : '+' }}
      </span>
                            </button>
                            <div *ngIf="faq.isOpen" class="px-4 py-3 text-gray-700 border-t border-gray-200">
                                {{ faq.answer }}
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <div class="mx-auto w-full mb-4 mt-8 md:mt-20">
                <h2 class="text-2xl md:text-3xl font-bold text-center mb-6">
                    STUDENT GRIEVANCE REDRESSAL COMMITTEE
                </h2>
                <iframe
                    src="assets/pdf/sgrc.pdf"
                    width="100%"
                    height="600px"
                    style="border: none;"
                ></iframe>
               <!-- <div class="overflow-x-auto bg-blue-100 shadow-xl">
                    <table class="min-w-full border border-gray-300 text-sm text-left">
                        <thead class="bg-emerald-500">
                        <tr>
                            <th class="border border-black/50 px-4 py-2">S No.</th>
                            <th class="border border-black/50 px-4 py-2">Name</th>
                            <th class="border border-black/50 px-4 py-2">Designation</th>
                            <th class="border border-black/50 px-4 py-2">Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let member of committeeMembers" class="hover:bg-emerald-100">
                            <td class="border border-black/50 px-4 py-2">{{ member.sno }}</td>
                            <td class="border border-black/50 px-4 py-2">{{ member.name }}</td>
                            <td class="border border-black/50 px-4 py-2">{{ member.designation }}</td>
                            <td class="border border-black/50 px-4 py-2">{{ member.status }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>-->
            </div>
        </div>
    </main>
</div>
